import * as actionTypes from '../actions/ActionTypes';

const initialCommonState = {
  videoTopicList: [],
  videosList: [],
  showVideoTopics: true,
};

const VideoTopicsReducer = (state = initialCommonState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_VIDEO_MAIN_TOPICS:
      return {
        ...state,
        videoTopicList: action.videoMainTopicArray,
        showVideoTopics: true,
      };

    case actionTypes.SHOW_VIDEOS:
      return {
        ...state,
        videosList: action.videosArray,
        showVideoTopics: false,
      };

    // case actionTypes.LOGOUT:
    //   return { ...initialCommonState };

    default:
      return state;
  }
};

export default VideoTopicsReducer;
